import { CompositeDecorator } from 'draft-js';
import { updateEntity as _updateEntity } from '../util/block';
import { LinkWrapper } from './LinkWrapper';
import { SelectedBlockWrapper } from './SelectedBlockWrapper';
import findLinkEntities from './findLinkEntities';
import findSelectedTextBlocks from './findSelectedTextBlocks';

var compositeDecoratorGenerator = function compositeDecoratorGenerator(_ref) {
  var setEditorState = _ref.setEditorState;
  return new CompositeDecorator([{
    strategy: findSelectedTextBlocks,
    component: SelectedBlockWrapper
  }, {
    strategy: findLinkEntities,
    component: LinkWrapper,
    props: {
      updateEntity: function updateEntity(entityKey) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var keepExistingSelection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        return setEditorState(function (editorState) {
          return _updateEntity(editorState, entityKey, data, keepExistingSelection);
        });
      }
    }
  }]);
};

export default compositeDecoratorGenerator;